"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _qr = require("./qr");
var _cipher = require("./ethereum/cipher");
var _myetherwallet = _interopRequireDefault(require("./ethereum/myetherwallet"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MessagingWalletAbstract = /*#__PURE__*/function (_Wallet) {
  (0, _inherits2["default"])(MessagingWalletAbstract, _Wallet);
  var _super = _createSuper(MessagingWalletAbstract);
  function MessagingWalletAbstract() {
    var _this;
    (0, _classCallCheck2["default"])(this, MessagingWalletAbstract);
    _this = _super.apply(this, arguments);
    _this.message_key = null;
    return _this;
  }
  (0, _createClass2["default"])(MessagingWalletAbstract, [{
    key: "publishMessageKey",
    value: function publishMessageKey() {
      var dataStr = JSON.stringify({
        address: this.getAddressString(),
        public_message_key: this.message_key.pub,
        private_message_key: this.message_key.priv
      });
      return this.ajaxReq.publishMessageKey(dataStr, this.signMessage(dataStr));
    }
  }, {
    key: "publishReqMessages",
    value: function () {
      var _publishReqMessages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(addTo, message) {
        var _this2 = this;
        var addFrom, pubKey, fromMsgKey, toMsgKey, dataStr;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              addFrom = this.getAddressString();
              pubKey = /*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(add) {
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.ajaxReq.getMessageKey(add, false);
                      case 2:
                        return _context.abrupt("return", _context.sent.public_message_key);
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function pubKey(_x3) {
                  return _ref.apply(this, arguments);
                };
              }();
              _context2.next = 4;
              return pubKey(addFrom);
            case 4:
              fromMsgKey = _context2.sent;
              _context2.next = 7;
              return pubKey(addTo);
            case 7:
              toMsgKey = _context2.sent;
              dataStr = JSON.stringify({
                add_req: addFrom,
                add_cli: addTo,
                ref_req: fromMsgKey ? (0, _cipher.cipherMsg)(fromMsgKey, message) : '',
                ref_cli: toMsgKey ? (0, _cipher.cipherMsg)(toMsgKey, message) : ''
              });
              return _context2.abrupt("return", this.ajaxReq.publishReqMessages(dataStr, this.signMessage(dataStr)));
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function publishReqMessages(_x, _x2) {
        return _publishReqMessages.apply(this, arguments);
      }
      return publishReqMessages;
    }()
  }, {
    key: "ensureWalletMessageKey",
    value: function () {
      var _ensureWalletMessageKey = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var remoteKey, walletMessageKey;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.ajaxReq.getMessageKey(this.getAddressString(), true);
            case 2:
              remoteKey = _context3.sent;
              walletMessageKey = this === null || this === void 0 ? void 0 : this.message_key;
              if (!(typeof remoteKey.public_message_key !== 'undefined')) {
                _context3.next = 9;
                break;
              }
              this.message_key = {
                pub: remoteKey.public_message_key,
                priv: remoteKey.private_message_key
              };
              if (!((walletMessageKey === null || walletMessageKey === void 0 ? void 0 : walletMessageKey.pub) !== remoteKey.public_message_key)) {
                _context3.next = 8;
                break;
              }
              return _context3.abrupt("return", 'REPLACED_WITH_REMOTE');
            case 8:
              return _context3.abrupt("return");
            case 9:
              if (!(!(walletMessageKey === null || walletMessageKey === void 0 ? void 0 : walletMessageKey.pub) || !(walletMessageKey === null || walletMessageKey === void 0 ? void 0 : walletMessageKey.priv))) {
                _context3.next = 13;
                break;
              }
              this.message_key = this.newMessageKey();
              this.publishMessageKey();
              return _context3.abrupt("return", 'CREATED_NEW');
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function ensureWalletMessageKey() {
        return _ensureWalletMessageKey.apply(this, arguments);
      }
      return ensureWalletMessageKey;
    }()
  }, {
    key: "getReqMessage",
    value: function () {
      var _getReqMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(otherAdd, myMessageKey, didISentThisMsg) {
        var myAdd, addFrom, addTo, data, crypted;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              myAdd = this.getAddressString();
              addFrom = didISentThisMsg ? myAdd : otherAdd;
              addTo = !didISentThisMsg ? myAdd : otherAdd;
              _context4.next = 5;
              return this.ajaxReq.getReqMessages(addFrom, addTo);
            case 5:
              data = _context4.sent;
              if (data) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", '');
            case 8:
              crypted = '';
              if (!(didISentThisMsg && data.ref_from)) {
                _context4.next = 13;
                break;
              }
              crypted = data.ref_from;
              _context4.next = 18;
              break;
            case 13:
              if (!(!didISentThisMsg && data.ref_to)) {
                _context4.next = 17;
                break;
              }
              crypted = data.ref_to;
              _context4.next = 18;
              break;
            case 17:
              return _context4.abrupt("return", '');
            case 18:
              _context4.prev = 18;
              return _context4.abrupt("return", (0, _cipher.decipherMsg)(myMessageKey, crypted));
            case 22:
              _context4.prev = 22;
              _context4.t0 = _context4["catch"](18);
              return _context4.abrupt("return", '');
            case 25:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[18, 22]]);
      }));
      function getReqMessage(_x4, _x5, _x6) {
        return _getReqMessage.apply(this, arguments);
      }
      return getReqMessage;
    }()
  }, {
    key: "newMessageKey",
    value: function newMessageKey() {
      var newKey = _myetherwallet["default"].generate(false);
      var mPub = newKey.getPublicKeyString();
      var mPriv = newKey.getPrivateKeyString();
      return {
        pub: mPub,
        priv: (0, _cipher.cipherMsg)(this.getPublicKeyString(), mPriv)
      };
    }
  }, {
    key: "messageKeysFromCrypted",
    value: function messageKeysFromCrypted(cipheredKey) {
      // XXXvlab: here we are converting to hex and de-converting in decipherMsg...
      return (0, _cipher.shortenAddress)((0, _cipher.decipherMsg)(this.getPrivateKeyString(), cipheredKey));
    }
  }, {
    key: "messageKeysFromWallet",
    value: function messageKeysFromWallet() {
      return this.messageKeysFromCrypted(this.message_key.priv);
    }
    //
    // Using currencyName
    //
  }, {
    key: "encryptWallet",
    value: function encryptWallet(password) {
      return this.toV3(password, {
        kdf: 'scrypt',
        n: 1024,
        server_name: this.currencyName,
        message_key: this.message_key
      });
    }
  }, {
    key: "enrollAddress",
    value: function enrollAddress(id, token) {
      return this.ajaxReq.enrollPost({
        id: id,
        token: token,
        currency: this.currencyName,
        // XXXvlab: Yes, typo is intentional here (in PHP API):
        adresse: this.getAddressString()
      });
    }
  }, {
    key: "requestUnlock",
    value: function requestUnlock() {
      return this.ajaxReq.requestUnlock(this.getAddressString(), this.unlockUrl);
    }
  }, {
    key: "makeSignedQRContent",
    value:
    //
    // QR Code helpers
    //
    function makeSignedQRContent(obj, pubKey) {
      return (0, _qr.makeSignedQRContent)(Object.assign(Object.assign({
        server: this.currencyName,
        address: this.getAddressString()
      }, obj), pubKey && {
        message_key: (0, _cipher.cipherMsg)(pubKey, this.messageKeysFromWallet())
      }), this.privKey);
    }
  }, {
    key: "makeSignedQRFragments",
    value: function makeSignedQRFragments(obj, fragmentCount, pubKey) {
      return (0, _qr.makeSignedQRFragments)(this.makeSignedQRContent(obj, pubKey), fragmentCount);
    }
  }, {
    key: "checkSignedQRFromString",
    value: function checkSignedQRFromString(qrString) {
      var qrContent;
      try {
        qrContent = JSON.parse(qrString);
      } catch (e) {
        return 'InvalidFormat';
      }
      return (0, _qr.checkSignedQR)(qrContent, this.getAddressString());
    }
  }], [{
    key: "createWallet",
    value: function () {
      var _createWallet = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var wallet;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              wallet = new this();
              _context5.next = 3;
              return wallet.ensureWalletMessageKey();
            case 3:
              return _context5.abrupt("return", wallet);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createWallet() {
        return _createWallet.apply(this, arguments);
      }
      return createWallet;
    }()
  }, {
    key: "getWalletFromPrivKeyFile",
    value: function getWalletFromPrivKeyFile(jsonStr, password) {
      var jsonArr = JSON.parse(jsonStr);
      if (jsonArr.encseed != null) return this.fromEthSale(jsonStr, password);else if (jsonArr.Crypto != null || jsonArr.crypto != null) {
        return this.fromV3(jsonStr, password, true);
      } else if (jsonArr.hash != null) {
        return this.fromMyEtherWallet(jsonStr, password);
      } else if (jsonArr.publisher === 'MyEtherWallet') {
        return this.fromMyEtherWalletV2(jsonStr);
      } else {
        throw new Error("Sorry! We don't recognize this type of wallet file.");
      }
    }
  }]);
  return MessagingWalletAbstract;
}(_myetherwallet["default"]);
exports["default"] = MessagingWalletAbstract;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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